export default "__VITE_ASSET__CrtGcIPH__"